import type { Messages } from '../i18n/de';

/**
 * Ein Schlüssel unter `t.persistence` — genau das, was `useToastStore.show()` entgegennimmt.
 * `string` bliebe zu lasch: ein Tippfehler im Schlüssel fiele erst zur Laufzeit auf, nicht beim
 * Bauen. Die nächste Aufgabe (Aufgabe 15) erweitert `persistence` um eigene Schlüssel; dieser
 * Typ wächst automatisch mit.
 */
export type PersistenceKey = keyof Messages['persistence'];

/**
 * Löst einen Sprachschlüssel im aktuell aktiven Katalog auf.
 *
 * Reine Funktion, absichtlich getrennt von `Toast.tsx`: das Projekt hat keine Infrastruktur,
 * um React-Bauteile in Tests zu rendern (`vitest.config.ts` läuft mit `environment: 'node'`,
 * keine Testing-Library) — also bleibt die eigentliche Entscheidung hier, wo sie ohne DOM
 * geprüft werden kann.
 *
 * Fehlt der Schlüssel im Katalog — sollte bei korrekter Typisierung nicht vorkommen, ist aber
 * zur Laufzeit nicht ausgeschlossen (z. B. ein Aufruf mit einem nicht geprüften String) —, zeigt
 * die Funktion den rohen Schlüssel: eine sichtbare Auffälligkeit ist dem Prüfer lieber als eine
 * stumme leere Box.
 */
export function resolveToastText(t: Messages, key: string): string {
  const entry = (t.persistence as Record<string, unknown>)[key];
  return typeof entry === 'string' ? entry : key;
}
